/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Budget_CapInputs */



/**
* | output |
* | --- |
* | "Overage budget cap" |
*
* @param {Usage_Tab_Budget_CapInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_budget_cap = /** @type {((inputs?: Usage_Tab_Budget_CapInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Budget_CapInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überschuss-Budgetgrenze")
	return /** @type {LocalizedString} */ ("Overage budget cap")
});